<template>
  <div class="report2022">
    <van-swipe ref="wanSwipe"
      class="my-swipe"
      :style="{ background: '#f5f8fa', width: swipeWidth + 'px', height: swipeHeight  + 'px'}"
      :duration="600"
      initial-swipe="0"
      @change="changePage"
      :loop="false"
      :stop-propagation="true"
      :show-indicators="false"
      :lazy-render="true"
      vertical>
      <van-swipe-item class="my-swipe-item" :immediate="false" v-for="(img, index) in imageArray" :key="img.url">
        <div class="itemBox" v-if="index < (currentIndex + 2) && index > (currentIndex -2)" :style="{backgroundImage: `url(${img.bgImage})`}">
          <img class="itemContent" :src="img.url"  @click="ceoplayVideoEvent(index)"/>
        </div>
        <div class="itemBox" v-else></div>
      </van-swipe-item>
    </van-swipe>
    <div class="videoBox" v-if="playVideo">
      <img class="backClose" @click="backClose" src="https://s2.51offer.com/51offer/20th-anniversary/close.jpg" />
      <video class="vjs-custom-skin" autoplay= controls :src="currentUrl">
        您的浏览器不支持视频播放。
      </video>
    </div>
    <img class="bluenext" v-if="showBluenextImg" src="https://s2.51offer.com/2021campaign/滑动按钮.png" @touchend="bluenextEvent" />
  </div>
</template>
<script>
// import { swiper, swiperSlide } from "vue-awesome-swiper";
// import "swiper/dist/css/swiper.css";
// import { videoPlayer } from 'vue-video-player'
// import 'video.js/dist/video-js.css'
// import 'vue-video-player/src/custom-theme.css'
import wx from 'weixin-js-sdk'
export default {
  name: 'propaganda',
  data () {
    return {
      currentUrl: '',
      imageArray: [
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P1-bg1.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-1.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P2-bg2.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-2.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P3-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P4-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P5-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P6-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P7-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P8-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P9-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P10-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P11-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P12-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P13-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P14-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P15-bg4.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg4.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P16-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P17-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P18-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P19-bg4.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg4.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P20-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P21-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P22-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P23-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P24-bg4.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg4.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P25-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P26-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P27-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P28-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P29-bg4.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg4.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P30-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P31-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P32-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P33-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P34-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P35-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P36-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P37-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P38-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P39-bg2.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-2.png'},
        {url: 'https://s2.51offer.com/51offer/report2022/h5/P40-bg3.png', bgImage: 'https://s2.51offer.com/51offer/report2022/h5/bg-3.png'},

      ],
      videoArray: [
        {index: 33, video: 'https://v1.51offer.com/campaignStudent.mp4'},
        {index: 35, video: 'https://v1.51offer.com/campaignCEO1.16.mp4'},
        {index: 36, video: 'https://v1.51offer.com/campaignCo.mp4'},
        {index: 37, video: 'https://v1.51offer.com/campaignSchool.mp4'}
      ],
      playVideo: false,
      wxHuangjing: false,
      playTime: '',
      current: '',
      currentIndex: 0,
      swipeHeight: document.documentElement.clientHeight,
      swipeWidth: document.documentElement.clientWidth,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: `${document.documentElement.clientWidth}:${document.documentElement.clientHeight - parseInt(70 * document.documentElement.clientWidth / 750)}`, // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"
        // aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: 'video/mp4', // 类型
          src: 'https://v2.51offer.com/2020summary/h5/demo.mp4' // url地址
        }],
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight - 210,
        poster: '', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false, // 当前时间和持续时间的分隔符
          durationDisplay: false, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
      nextPage: true,
      videoInfoUrl: 'https://s2.51offer.com/2020summary/h5/st:video:p:201:1:1.png',
      showBluenextImg: true,
      bluenextImg: 'https://s2.51offer.com/2020summary/h5/whitenext.png'
    }
  },
  // components: { videoPlayer },
  created () {
    if (this.$route.query.page) {
      if (Number.isInteger(this.$route.query.page - 1) && (this.$route.query.page - 1) < 40) {
        this.currentIndex = this.$route.query.page - 1
      }
    }
    this.sureWH()
    window.onresize = () => this.sureWH()
    if (this.getIsWxClient()) { // 微信环境 初始化微信 jsdk
      this.wxInit()
      this.wxHuangjing = true
    }
  },
  mounted () {
    window.log('send', 'click', 'as_2020_page', 'loading', 1)
    let swiper = this.$refs.wanSwipe
    let swipeStart = this.currentIndex
    swiper.touchStart = (start) => {
      this.nextPage = true
      swipeStart = start.changedTouches[0].clientY
    }
    swiper.touchMove = (end) => {
      if (!this.nextPage) return
      if (swipeStart - end.changedTouches[0].clientY > 80 && this.nextPage) {
        if (this.getScrollTop() + this.getWindowHeight() - this.getScrollHeight() === 0) {
          this.nextPage = false
          swiper.next()
          this.getScrollTop(true)
        }
      }
      if (end.changedTouches[0].clientY - swipeStart > 80 && this.nextPage) {
        if (this.getScrollTop() === 0) {
          this.nextPage = false
          swiper.prev()
          this.getScrollTop(true)
        }
      }
    }
    if (this.currentIndex > 0) {
      swiper.swipeTo(this.currentIndex)
    }
    document.body.addEventListener('touchmove', function (event) {
      event.preventDefault() // 阻止元素发生默认的行为
    }, {passive: false})
  },
  beforeRouteLeave (to, from, next) {
    this.$refs.videoPlayer.player.pause()
    next()
  },
  methods: {
    sureWH () {
      let clientHeight = document.documentElement.clientHeight
      let clientWidth = document.documentElement.clientWidth
      if ((clientWidth / clientHeight) > 0.7) {
        this.swipeWidth = clientHeight / (1624 / 750)
        this.swipeHeight = clientHeight
      } else {
        this.swipeWidth = clientWidth
        this.swipeHeight = clientHeight
      }
    },
    changePage (index) {
      this.currentIndex = index
      if (index === 39 ) {
        this.showBluenextImg = false
      } else  this.showBluenextImg = true
    },
    ceoplayVideoEvent (index) {
      if ([33, 35, 36, 37].includes(index)) {
        this.playerOptions.sources[0].src = this.videoArray.filter(_ => _.index == index)[0].video
        this.currentUrl = this.videoArray.filter(_ => _.index == index)[0].video
        this.playVideo = true
        // this.playTime = '',
        // this.current = '',
        // this.$nextTick(() => {
        //   setTimeout(() => {
        //     if (!this.$refs.videoPlayer) {
        //       this.ceoplayVideoEvent(index)
        //     } else this.$refs.videoPlayer.player.play()
        //   }, 100)
        // })
      } else this.playVideo = false
    },
    bluenextEvent () {
      this.$refs.wanSwipe.next()
      this.getScrollTop(true)
    },
    getIsWxClient () {
      if (/(MicroMessenger)/i.test(navigator.userAgent)) {
        return true
      }
      return false
    },
    backClose () {
      this.playVideo = false
    },
    // 播放回调
    onPlayerPlay (player) {
      console.log('player play!', player)
    },
    // 暂停回调
    onPlayerPause (player) {
      console.log('player pause!', player)
    },
    // 视频播完回调
    onPlayerEnded ($event) {
      console.log($event)
    },
    // DOM元素上的readyState更改导致播放停止
    onPlayerWaiting (player) {
      let time = localStorage.getItem('cacheTime')
      if (player.cache_.currentTime - Number(time) > 0.1) {
        this.current = Number(time)
        this.playerReadied(player)
      } else {
        this.current = player.cache_.currentTime
      }
    },
    // 已开始播放回调
    onPlayerPlaying ($event) {
      console.log($event)
    },
    // 当播放器在当前播放位置下载数据时触发
    onPlayerLoadeddata ($event) {
      console.log($event)
    },
    // 当前播放位置发生变化时触发。
    onPlayerTimeupdate (player) {
      this.playTime = player.cache_.currentTime
      let playTime = player.cache_.currentTime
      setTimeout(function () {
        localStorage.setItem('cacheTime', playTime)
      }, 500)
      let time = localStorage.getItem('cacheTime')
      if (player.cache_.currentTime - Number(time) > 2) {
        this.current = Number(time)
        this.playerReadied(player)
      } else {
        this.current = player.cache_.currentTime
      }
    },
    // 媒体的readyState为HAVE_FUTURE_DATA或更高
    onPlayerCanplay (player) {
      console.log('player Canplay!', player)
    },
    // 媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
    onPlayerCanplaythrough (player) {
      console.log('player Canplaythrough!', player)
    },
    // 播放状态改变回调
    playerStateChanged (playerCurrentState) {
      console.log('player current update state', playerCurrentState)
    },
    // 将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
    playerReadied (player) {
      player.currentTime(this.current)
    },
    // 获取滑动位置
    getScrollTop (isTop) {
      if (isTop) {
        document.body.scrollTop = document.documentElement.scrollTop = 0
        return
      }
      let scrollTop = 0
      let bodyScrollTop = 0
      let documentScrollTop = 0
      if (document.body) {
        bodyScrollTop = document.body.scrollTop
      }
      if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop
      }
      scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop
      return scrollTop
    },
    // 文档的总高度
    getScrollHeight () {
      let scrollHeight = 0
      let bodyScrollHeight = 0
      let documentScrollHeight = 0
      if (document.body) {
        bodyScrollHeight = document.body.scrollHeight
      }
      if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight
      }
      scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight
      return scrollHeight
    },
    // 浏览器视口的高度
    getWindowHeight () {
      let windowHeight = 0
      if (document.compatMode === 'CSS1Compat') {
        windowHeight = document.documentElement.clientHeight
      } else {
        windowHeight = document.body.clientHeight
      }
      return windowHeight
    },
    // 初始化微信jsdk
    wxInit () {

      if (!wx) {
        setTimeout(() => {
          this.wxInit()
        }, 100)
        return
      }
      if (!sessionStorage.getItem('initLink')) {
        sessionStorage.setItem('initLink', document.URL)
      }

      let appid = window.appid
      let noncestr = window.noncestr
      let timestamp = window.timestamp
      let signature = window.signature
      let dataForWeixin = {
        appId: appid,
        MsgImg: 'https://s2.51offer.com/2022/d43d90727d97482fac181172348374cc.jpg',
        TLImg: 'https://s2.51offer.com/2022/d43d90727d97482fac181172348374cc.jpg',
        // url: sessionStorage.getItem('initLink') || 'https://m.51offer.com/2021/annualsummary.html#/',
        url: window.location.href.split('#')[0] || 'https://m.51offer.com/2021/annualsummary.html',
        title: '2022留学行业年度报告出炉！',
        desc: '留学需求呈现多样化，海归回流趋势渐强，以数据视角共议国际竞争力人才发展',
        timestamp: timestamp,
        nonceStr: noncestr,
        signature: signature,
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'],
        fakeid: '',
        callback: function () {
        }
      }
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: dataForWeixin.appId, // 必填，公众号的唯一标识
        timestamp: dataForWeixin.timestamp, // 必填，生成签名的时间戳
        nonceStr: dataForWeixin.nonceStr, // 必填，生成签名的随机串
        signature: dataForWeixin.signature, // 必填，签名，见附录1
        jsApiList: dataForWeixin.jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      })
      console.log(wx, dataForWeixin)
      wx.ready(function (res) {
        console.log('回调的参数：' + res)
        // 在此输入各种API
        // “分享给朋友”
        wx.onMenuShareAppMessage({
        // wx.updateAppMessageShareData({ 
          title: dataForWeixin.title, // 分享标题
          link: dataForWeixin.url, // 分享链接
          desc: dataForWeixin.desc, // 分享文案
          imgUrl: dataForWeixin.MsgImg, // 分享图标
          success: function () {
            // alert('分享成功', res)
          },
          complete: function () {
          },
          cancel: function (err) {
            // 用户取消分享后执行的回调函数
            console.log('用户取消', err)
          }
        })
        // “分享到朋友圈”
        wx.onMenuShareTimeline({
        // wx.updateTimelineShareData({
          title: dataForWeixin.title, // 分享标题
          desc: dataForWeixin.desc, // 分享描述
          link: dataForWeixin.url, // 分享链接
          imgUrl: dataForWeixin.TLImg, // 分享图标
          type: 'link', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: function () {
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          }
        })
        // QQ
        wx.onMenuShareQQ({
          title: dataForWeixin.title, // 分享标题
          desc: dataForWeixin.desc, // 分享描述
          link: dataForWeixin.url, // 分享链接
          imgUrl: dataForWeixin.MsgImg, // 分享图标
          success: function () {
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          }
        })
        // QQ微博
        wx.onMenuShareWeibo({
          title: dataForWeixin.title, // 分享标题
          desc: dataForWeixin.desc, // 分享描述
          link: dataForWeixin.url, // 分享链接
          imgUrl: dataForWeixin.TLImg, // 分享图标
          success: function () {
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          }
        })
        // QQ空间
        wx.onMenuShareQZone({
          title: dataForWeixin.title, // 分享标题
          desc: dataForWeixin.desc, // 分享描述
          link: dataForWeixin.url, // 分享链接
          imgUrl: dataForWeixin.TLImg, // 分享图标
          success: function () {
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          }
        })
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，
        // 所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      })
      wx.error(function (res) {
        console.log('config失败', res)
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
h1, h2 {
  font-weight: normal;
}
html, body {
  background: #001b5d;
  overflow: hidden;
}
.report2022 {
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  background: #001b5d;
  position: relative;
  .itemBox {
    width: 100%;
    height: 100%;
    background-size: 100%;
    background-repeat:no-repeat;
    position: relative;
    .itemContent {
      width: 100%;
      height: auto;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
}
.my-swipe {
  transform: translate3d(0, 0, 0);
  overflow: hidden;
}
.my-swipe .van-swipe-item {
  width: 100%;
  height: 8rem;
  color: #000;
  font-size: 30px;
  line-height: 150px;
  text-align: center;
  margin: 0 auto;
  background-color: #001b5d;
}
.my-swipe .my-swipe-item {
  transform: translate3d(0, 0, 0);
}
.imgBox {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}
.imgBox img {
  border-radius: .1rem;
}
.backClose {
  width: .5rem;
  position: absolute;
  top: .2rem;
  right: .2rem;
  z-index: 1;
}

.videoBox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  padding: 1rem .15rem;
  box-sizing: border-box;
  background: #000;
}
.backClose {
  width: .4rem;
  position: absolute;
  top: .3rem;
  right: .3rem;
  z-index: 1;
}
.vjs-custom-skin {
  width: 100%;
  height: calc(100% - 1.2rem);
  margin: .9rem auto 0;
}
.vjs-custom-skin > .video-js .vjs-tech {
  height: calc(100% - 1.6rem);
  margin: .9rem auto 0;
}
.vjs-custom-skin > .video-js .vjs-big-play-button {
    background-color: rgba(0,0,0,0.45);
    font-size: 2.0rem;
    border-radius: 50%;
    height: .5rem !important;
    line-height:.5rem !important;
    margin-top: -1rem !important;
}
.bluenext {
  width: .40rem;
  position: fixed;
  bottom: .6rem;
  left: 0;
  right: 0;
  margin: auto;
}
</style>
